import React from 'react'
import EditIcon from '@material-ui/icons/Edit';
import "./ImageCom.scss"
import Dropzone from 'react-dropzone';
import Resizer from "react-image-file-resizer";

function ImageCom({ src, angle, handleModal, images, imageIndex,setState ,onChange  }) {
    
    const handleClick = () => {
        if (src) {            
            handleModal(images<imageIndex?images:imageIndex);
        }
    };


    const onDrop = (accepted, rejected) => {
        if (Object.keys(rejected).length !== 0) {
            // const message = "Please submit valid file type";
            // this.setState({ warningMsg: message });
        } else {
            const blobPromise = new Promise((resolve, reject) => {
                const reader = new window.FileReader();
                reader.readAsDataURL(accepted[0]);
                reader.onloadend = () => {
                    const base64data = reader.result;
                    resolve(base64data);
                };
            });
            blobPromise.then((value) => {
                accepted[0].base64 = value;
                addFile(accepted);
                // this.setState({ warningMsg: "" });
            });
        }
    };

    function renameImage(imageFile) {
        const [name, extension] = imageFile.name.split('.');
        return `${name}_${+new Date()}.${extension}`;
    };

    function toBase64(imageFile) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(imageFile);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }

    function addFile(imageFiles) {
        const imageFile = imageFiles[0];
        const name = renameImage(imageFile);
        resizeImage(imageFile, async (compressedImage) => {
            const base64 = await toBase64(compressedImage);
            const file = [
                Object.assign(new File([compressedImage], name), {
                    preview: URL.createObjectURL(compressedImage),
                    base64
                })
            ];

            setState({ file });
            onChange({ file });
        })
    }
    async function resizeImage(file, callback) {
        return Resizer.imageFileResizer(
            file,
            1080,
            1440,
            "jpeg",
            75,
            0,
            (file) => {
                callback(file);
            },
            "file"
        );
    }
    
  return (
      <div className="profile-pic">
          <img src={src} alt={angle}
            onClick={handleClick}
              style={{
                  width: "120px",
                  height: "150px",
                  objectFit: "cover",
                  objectPosition: "center",
                  marginLeft: angle === "Back" ? '15px' : 0,
                
              
              }} />
              <Dropzone
              className='edit'
              style={{
                  width: "120px",
                  height:'30px',
              objectFit: "cover",
              objectPosition: "center",
              marginLeft: angle === "Back" ? '15px' : 0,

              }}
                    multiple={false}
                    accept="image/*"
                    onDrop={(accepted, rejected) => onDrop(accepted, rejected)}
                >
                    {({ isDragAccept, isDragReject, acceptedFiles, rejectedFiles }) => {
                        // for drag and drop warning statement
                        
                        if (isDragReject) return "Please submit a valid file";
                        
                        return<EditIcon style={{color:'#fff',padding:0}} />

                    }}
                </Dropzone>
      </div>
  )
}

export default ImageCom;